var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex align-items-center flex-grow-1",staticStyle:{"height":"24px"}},[_c('input',{ref:"rangeInput",attrs:{"type":"range","min":_vm.min,"max":_vm.max,"step":_vm.step},domProps:{"value":_vm.value}})])}
var staticRenderFns = []

export { render, staticRenderFns }